/**
 * Detects the missing DST hour for a given date in the browser's timezone.
 * During DST "spring forward", one hour is skipped (e.g., 2:00 AM becomes 3:00 AM).
 * Returns the hour that is missing, or null if no DST transition occurs.
 */
export function getMissingDstHour(date: Date): number | null {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  for (let hour = 0; hour < 24; hour++) {
    const testDate = new Date(year, month, day, hour, 0, 0, 0);
    if (testDate.getHours() !== hour) {
      return hour;
    }
  }

  return null;
}
